// строки из logger.error, которые не являются поломкой:
// сетевые переподключения, автоплей, пермишены и то, что мы репортим явно (см. ./report)
export const IGNORED_CONSOLE_MESSAGES = [
    // дубли глобальных обработчиков из index.web.js, sentry ловит их сам
    /^UnhandledError:/,
    /^UnhandledPromiseRejection:/,
    // репортим явно из middleware
    /CONFERENCE FAILED:/,
    /conference\.connectionError/,
    /track creation failed with error/,
    /failed to share local desktop/,
    /Error while obtaining desktop sources/,
    /^JWT error:/,
    /^JWT parsing errors:/,
    // автоплей и wake lock — ограничения браузера
    /Error while trying to playing/,
    /Error while requesting wake lock/,
    // штатные состояния сети, итог видим через CONNECTION_FAILED / CONFERENCE_FAILED
    /Channel closed/,
    /Channel error/,
    /Trying to send stanza while/,
    /Strophe: Websocket/,
    /Ping timeout/,
    /PING error\/timeout/,
    /XMPP connection dropped/,
    /Websocket Keep alive failed/,
    /triggering ice restart/
];
// исключения, которые бросает браузер на действия/отказы пользователя
export const IGNORED_EXCEPTIONS = [
    // автоплей
    /^NotAllowedError: play\(\)/,
    /^NotAllowedError: A user gesture is required/,
    /^NotAllowedError: The request is not allowed by the user agent/,
    /^AbortError: The play\(\) request was interrupted/,
    /^AbortError: The operation was aborted/,
    /^AbortError: The operation could not be performed and was aborted/,
    // сырые ошибки getUserMedia, репортим явно как ошибки устройств
    /^gum\./,
    /^NotFoundError: Requested device not found/,
    /^NotReadableError: (Could not start (video|audio) source|Device in use)/,
    /^NotAllowedError: Permission denied/,
    // reject промиса строкой-кодом конференции, репортим явно
    /Non-Error promise rejection captured with value: conference\./,
    // ошибка из чужого origin, в ней нет никакой информации
    /^Script error\.?$/
];
export const isIgnoredConsoleMessage = (message) => IGNORED_CONSOLE_MESSAGES.some(re => re.test(message));
export const isIgnoredException = (type, value) => {
    const text = type ? `${type}: ${value ?? ''}` : value ?? '';
    return IGNORED_EXCEPTIONS.some(re => re.test(text) || (value !== undefined && re.test(value)));
};
